import React, { useState } from "react";
import { CloseOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import confirmBox from "../../CoreComponents/confirmBox";
import { addSlab, removeSlab, updateSlab } from "./riderLogic";

const EMPTY = { ordersUpto: "", amount: "" };

const slabText = (slab) => `≤ ${slab.ordersUpto} orders · ₹${slab.amount} each`;

export default function IncentiveSlabs({ slabs, onChange }) {
  const [form, setForm] = useState(EMPTY);
  const [editing, setEditing] = useState(null);

  const reset = () => {
    setForm(EMPTY);
    setEditing(null);
  };

  const submit = (event) => {
    event.preventDefault();
    if (!form.ordersUpto || !form.amount) return;
    onChange(editing === null ? addSlab(slabs, form) : updateSlab(slabs, editing, form));
    reset();
  };

  const edit = (index) => {
    setEditing(index);
    setForm({ ordersUpto: String(slabs[index].ordersUpto), amount: String(slabs[index].amount) });
  };

  const remove = (index) =>
    confirmBox({
      title: "Delete this slab?",
      message: slabText(slabs[index]),
      yesLabel: "Delete",
      noLabel: "Cancel",
      onYes: () => {
        onChange(removeSlab(slabs, index));
        reset();
      },
    });

  return (
    <section className="stl-card stl-slabs">
      <div className="stl-slabs__intro">
        <span className="stl-title">Incentive slabs</span>
        <span className="stl-subtitle">Prefill each rider's incentive</span>
      </div>
      <div className="stl-chips">
        {slabs.length === 0 ? (
          <span className="stl-subtitle">No slabs. The incentive starts at ₹0 and can be typed per rider.</span>
        ) : (
          slabs.map((slab, index) => (
            <span key={index} className={`stl-chip${editing === index ? " stl-chip--editing" : ""}`}>
              {slabText(slab)}
              <button type="button" className="stl-chip__btn" aria-label={`Edit ${slabText(slab)}`} onClick={() => edit(index)}>
                <EditOutlined />
              </button>
              <button
                type="button"
                className="stl-chip__btn stl-chip__btn--danger"
                aria-label={`Delete ${slabText(slab)}`}
                onClick={() => remove(index)}
              >
                <CloseOutlined />
              </button>
            </span>
          ))
        )}
        {slabs.length > 0 && (
          <button type="button" className="stl-link-btn" onClick={() => { onChange([]); reset(); }}>
            Clear all
          </button>
        )}
      </div>
      <form className="stl-slab-form" onSubmit={submit}>
        <input
          className="stl-input stl-input--sm"
          type="number"
          min="1"
          placeholder="Orders up to"
          aria-label="Orders up to"
          value={form.ordersUpto}
          onChange={(e) => setForm((prev) => ({ ...prev, ordersUpto: e.target.value }))}
          required
        />
        <input
          className="stl-input stl-input--sm"
          type="number"
          min="0"
          placeholder="₹ per order"
          aria-label="Rupees per order"
          value={form.amount}
          onChange={(e) => setForm((prev) => ({ ...prev, amount: e.target.value }))}
          required
        />
        <button type="submit" className="stl-btn stl-btn--secondary stl-btn--sm">
          {editing === null ? (
            <>
              <PlusOutlined /> Add slab
            </>
          ) : (
            "Save slab"
          )}
        </button>
        {editing !== null && (
          <button type="button" className="stl-link-btn" onClick={reset}>
            Cancel
          </button>
        )}
      </form>
    </section>
  );
}
